/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Timestamp } from "../google/protobuf/timestamp";

export const protobufPackage = "Reality.Reality.Api";

/**
 * <strong>GET /api/v2/wise_account/get</strong>
 * wise用アカウント情報を取得する
 */
export interface WiseAccountGetResponse {
  vliveId: string;
  firstName: string;
  lastName: string;
  region: string;
  email: string;
  accountLastUpdatedAt: Date | undefined;
  canCashTransfer: boolean;
}

function createBaseWiseAccountGetResponse(): WiseAccountGetResponse {
  return {
    vliveId: "",
    firstName: "",
    lastName: "",
    region: "",
    email: "",
    accountLastUpdatedAt: undefined,
    canCashTransfer: false,
  };
}

export const WiseAccountGetResponse = {
  encode(message: WiseAccountGetResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.vliveId !== "") {
      writer.uint32(10).string(message.vliveId);
    }
    if (message.firstName !== "") {
      writer.uint32(18).string(message.firstName);
    }
    if (message.lastName !== "") {
      writer.uint32(26).string(message.lastName);
    }
    if (message.region !== "") {
      writer.uint32(34).string(message.region);
    }
    if (message.email !== "") {
      writer.uint32(42).string(message.email);
    }
    if (message.accountLastUpdatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.accountLastUpdatedAt), writer.uint32(50).fork()).ldelim();
    }
    if (message.canCashTransfer === true) {
      writer.uint32(56).bool(message.canCashTransfer);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WiseAccountGetResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWiseAccountGetResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.vliveId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.firstName = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.lastName = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.region = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.email = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.accountLastUpdatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.canCashTransfer = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WiseAccountGetResponse {
    return {
      vliveId: isSet(object.vliveId) ? globalThis.String(object.vliveId) : "",
      firstName: isSet(object.firstName) ? globalThis.String(object.firstName) : "",
      lastName: isSet(object.lastName) ? globalThis.String(object.lastName) : "",
      region: isSet(object.region) ? globalThis.String(object.region) : "",
      email: isSet(object.email) ? globalThis.String(object.email) : "",
      accountLastUpdatedAt: isSet(object.accountLastUpdatedAt)
        ? fromJsonTimestamp(object.accountLastUpdatedAt)
        : undefined,
      canCashTransfer: isSet(object.canCashTransfer) ? globalThis.Boolean(object.canCashTransfer) : false,
    };
  },

  toJSON(message: WiseAccountGetResponse): unknown {
    const obj: any = {};
    if (message.vliveId !== "") {
      obj.vliveId = message.vliveId;
    }
    if (message.firstName !== "") {
      obj.firstName = message.firstName;
    }
    if (message.lastName !== "") {
      obj.lastName = message.lastName;
    }
    if (message.region !== "") {
      obj.region = message.region;
    }
    if (message.email !== "") {
      obj.email = message.email;
    }
    if (message.accountLastUpdatedAt !== undefined) {
      obj.accountLastUpdatedAt = message.accountLastUpdatedAt.toISOString();
    }
    if (message.canCashTransfer === true) {
      obj.canCashTransfer = message.canCashTransfer;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WiseAccountGetResponse>, I>>(base?: I): WiseAccountGetResponse {
    return WiseAccountGetResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WiseAccountGetResponse>, I>>(object: I): WiseAccountGetResponse {
    const message = createBaseWiseAccountGetResponse();
    message.vliveId = object.vliveId ?? "";
    message.firstName = object.firstName ?? "";
    message.lastName = object.lastName ?? "";
    message.region = object.region ?? "";
    message.email = object.email ?? "";
    message.accountLastUpdatedAt = object.accountLastUpdatedAt ?? undefined;
    message.canCashTransfer = object.canCashTransfer ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
